/**
 * Character counter component for textareas
 * Displays current/max character count and updates in real-time
 */
export default () => ({
    current: 0,
    max: 0,
    textarea: null,

    init() {
        this.textarea = this.$el.querySelector('textarea');
        this.max = this.textarea?.maxLength || 0;
        this.current = this.textarea?.value.length || 0;
    },

    updateCount() {
        this.current = this.textarea?.value.length || 0;
    }
});
